import { createFileRoute, Outlet } from "@tanstack/react-router";

function SalonLayout() {
  return <Outlet />;
}

/** Layout: hijos en index, comanda, split-check. */
export const Route = createFileRoute("/app/salon")({
  component: SalonLayout,
});
